<template>

	<div fluid style="width: 100%; height: 100%;" width="100%" height="100%">
		
		<v-card tile class="elevation-0" :width="leftMenuPaneWidth" height="100%"><!--  -->


			<v-navigation-drawer
				absolute
				clipped
				permanent

				:mini-variant="isMiniDrawer"

				z-index="5"
				width="100%"
				class="secondary"
			>

				<v-subheader class="subtitle-1 font-weight-bold mt-4 brightTitle--text hidden-xs-only" style="text-transform: uppercase;">Projects</v-subheader>


				<v-list dark>
					<v-list-item
						v-for="item in menuItemsOther"
						:key="item.title"
						router :to="item.route"
					>
						<v-list-item-action>
						<v-icon color="accent">{{ item.icon }}</v-icon>
						</v-list-item-action>

						<v-list-item-content class="ml-n4">
							<v-list-item-title>
								{{ item.title }}
							</v-list-item-title>
						</v-list-item-content>

					</v-list-item>
				</v-list>



				<!-- <v-subheader class="subtitle-1 font-weight-bold mt-4 brightTitle--text hidden-xs-only" style="text-transform: uppercase;">User management</v-subheader>

				<v-list dark>
					<v-list-item
						v-for="item in menuItemsUser"
						:key="item.title"
						router :to="item.route"
					>
						<v-list-item-action>
						<v-icon color="accent">{{ item.icon }}</v-icon>
						</v-list-item-action>

						<v-list-item-content class="ml-n4">
							<v-list-item-title>
								{{ item.title }}
							</v-list-item-title>
						</v-list-item-content>

					</v-list-item>
				</v-list> -->

				
				
			</v-navigation-drawer>
		</v-card>

		<v-card :style="`left: ${leftMenuPaneWidth}px;'`" class="ai-cardPaneScrollTweak elevation-0" :width="rightContentPaneWidth" tile height="100%">
			<router-view></router-view>
		</v-card>

	</div>
	
</template>

<script>


// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from "@/shift/agile";

export default
{
	name: "AdminProjects",

	// ----------------------------------
	//	Data
	// ----------------------------------

	data: () =>
	({
		leftPaneWidth: 25,
		leftMenuPaneWidth: 50,
		rightContentPaneWidth: 50,

		isMiniDrawer: false,

		menuItemsUser: [
            { title: 'Active users', icon: 'mdi-account-multiple', route: '/admin/users/active' },
            { title: 'Disabled users', icon: 'mdi-delete', route: '/admin/users/disabled' },//route: '/admin/disabledusers' },
            /*{ title: 'Roles and permissions', icon: 'mdi-account-group', route: '/admin/roles' },*/
        ],

        menuItemsOther: [
			{ title: 'Projects', icon: 'mdi-television-clean', route: '/admin/projects' },
			{ title: 'Groups', icon: 'mdi-animation', route: '/admin/groups' },//mdi-file-tree
			{ title: 'Clients', icon: 'mdi-account-group', route: '/admin/clients' },//mdi-window-open
            { title: 'Disabled projects', icon: 'mdi-delete', route: '/admin/disabledprojects' },
        ],

	}),


	// ----------------------------------
	//	Computed properties
	// ----------------------------------

	computed:
	{
		appBarHeight() {
			return agile.appBarHeight();
		},
		toolBarPrimaryHeight() {
			return agile.toolBarPrimaryHeight();
		},
		toolBarSecondaryHeight() {
			return agile.toolBarSecondaryHeight();
		}
	},


	// ----------------------------------
	//	Created
	// ----------------------------------

	created()
	{
		window.onresize = this.onResize.bind(this);
	},

	mounted()
	{
		this.onResize();
	},


	// ----------------------------------
	//	Methods
	// ----------------------------------

	methods:
	{
		onResize()
		{
			// Todo: Oh my god boring coding
			if (window.innerWidth < 600)
			{
				this.isMiniDrawer = true;
				this.leftMenuPaneWidth = 56;	//xs
			}
			else if (window.innerWidth < 960)
			{
				this.isMiniDrawer = false;
				this.leftMenuPaneWidth = 260;	//sm
			}
			else if (window.innerWidth < 1264)
			{
				this.isMiniDrawer = false;
				this.leftMenuPaneWidth = 280;	//md
			}
			else if (window.innerWidth < 1904)
			{
				this.isMiniDrawer = false;
				this.leftMenuPaneWidth = 300;	//lg
			}
			else
			{
				this.isMiniDrawer = false;
				this.leftMenuPaneWidth = 320;	//xl
			}
			
			this.rightContentPaneWidth = window.innerWidth-this.leftMenuPaneWidth;
		},
		
	},



	// ----------------------------------
	//	Components
	// ----------------------------------

	components:
	{
		
	}
};
</script>